var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSetInitviewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 101",
    style: {
      enableBackground: "new 0 0 100 101"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.6;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{opacity:0.9;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 49.7,
    cy: 85.8,
    rx: 38.1,
    ry: 11.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "person"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41,60h-3.4c-1.7,0-3.1-1.3-3.3-3c-0.7-5.6-2.1-17.8-3-24.6c-0.2-1.2,0.2-2.5,1.1-3.4c0.8-0.9,2-1.5,3.3-1.5 H65c1.3,0,2.4,0.5,3.3,1.5s1.2,2.2,1.1,3.4c-0.8,6.8-2.3,19-3,24.6c-0.2,1.7-1.6,3-3.3,3h-3.4l-1,17.7c-0.3,4.4-3.9,7.8-8.3,7.8 s-8-3.4-8.3-7.8L41,60L41,60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50,6.9c5.7,0,10.3,4.6,10.3,10.3S55.7,27.5,50,27.5s-10.3-4.6-10.3-10.3S44.3,6.9,50,6.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetInitviewIcon);
export default __webpack_public_path__ + "static/media/set-initview-icon.1087c64dbd910f7b2b7f9a07674ad095.svg";
export { ForwardRef as ReactComponent };